export function showByPermission(permission: string) {
  return permission !== 'hidden'
}

export function disabledByPermission(permission: string) {
  return permission.startsWith('disabled')
}
